import { useMobile } from "@/hooks";
import trackClevertapEvents from "@/utils/trackClevertapEvents";
import { Modal } from "@monsterindia/global-ui-components";
import React from "react";

import UnsubscribePage from "../../unsubscribe";
import { OutreachSubscriptionState } from "../../unsubscribe/types/unsubscribe";

type OutreachSubscriptionModalProps = {
  outreachSubscriptionData: OutreachSubscriptionState;
  setOutreachSubscriptionData: React.Dispatch<
    React.SetStateAction<OutreachSubscriptionState>
  >;
};

const OutreachSubscriptionModal: React.FC<OutreachSubscriptionModalProps> = ({
  outreachSubscriptionData,
  setOutreachSubscriptionData,
}) => {
  const isMobile = useMobile();

  const handleCloseModal = () => {
    setOutreachSubscriptionData({
      ...outreachSubscriptionData,
      unsubscribeModalOpen: false,
    });
  };

  return (
    <div className="">
      <Modal
        screenAlignment={isMobile ? "bottom-sheet" : "center"}
        showModal={outreachSubscriptionData.unsubscribeModalOpen}
        closeModal={handleCloseModal}
        showCloseButton={true}
        showHandleBar={isMobile}
        customClass="rounded-lg bg-[var(--Surface-Primary-Normal,_#FFF)] shadow-[0_4px_4px_-2px_rgba(0,0,0,0.10),_0_12px_16px_-6px_rgba(0,0,0,0.15)] pb-0"
      >
        <UnsubscribePage
          isMobile={isMobile}
          recruiterName={"TechCorp Solutions"}
          corpId={"TCS123"}
          unSubscriptionDuration={"3"}
          type="settings"
          setOutreachSubscriptionData={setOutreachSubscriptionData}
        />
      </Modal>
    </div>
  );
};

export default OutreachSubscriptionModal;
